import { Box, CheckBox, IconNew, IconNewOptions, ModBox, SpacerNew, TextNew } from '@jfs/ui-new'
import React, { Fragment, useCallback } from 'react'
import { useStores } from '../../data/store'
import { Dropdown } from '../Dropdown'
import { newHeaderMap } from './Fixtures'
import { styles } from './styles'

interface ListHeaderComponentInterface {
  isSelectAllChecked: boolean
  onHeaderSelectionChange: (selectedItem: any) => void
  isEditMode?: boolean
  cardsSelectDeselectAll: (isSelected: boolean, cardType: string) => void
  cardsColumnSelectionChange: (columnName: string, isSelected: boolean) => void
}

const arrowedName = (title: string, iconName: IconNewOptions) => {
  return (
    <ModBox flexDirection={'row'} alignSelf={'flex-start'}>
      <TextNew fontSize={10} color={'DARK_GREY'} title={title} />
      <SpacerNew size={6} direction={'horizontal'} />
      <IconNew id={iconName} color={'GREY_MATTE'} size={18} />
    </ModBox>
  )
}

const CheckboxDropdown = ({
  onHeaderSelectionChange,
  isSelectAllChecked,
  setSelectedCardTypeChecked,
  isEditMode,
  selectedCardType,
  cardsTypeDropdownData,
  cardsSelectDeselectAll,
}: any) => {
  const numOfColumns = newHeaderMap?.length

  const setCardTypeData = (item: any) => {
    onHeaderSelectionChange(item)
  }
  const onSelectAllPress = useCallback(() => {
    const selectState = !isSelectAllChecked
    setSelectedCardTypeChecked(selectState)
    cardsSelectDeselectAll(selectState, selectedCardType)
  }, [cardsSelectDeselectAll, isSelectAllChecked, selectedCardType, setSelectedCardTypeChecked])

  return (
    <Box {...styles.cardSuperView}>
      <Box {...styles.cardTypeTextContainer}>{arrowedName('Card Type', 'ARROW_RIGHT')}</Box>
      <Box {...styles.cardTypeBox(numOfColumns)}>
        <Box {...styles.dropdownContainer}>
          <Box {...styles.checkboxContainerDropdown}>
            <CheckBox
              checked={isSelectAllChecked}
              iconSize={20}
              color={isEditMode ? (isSelectAllChecked ? 'BLUE' : 'GREY_MATTE') : 'DARK_GREY'}
              onChange={onSelectAllPress}
              disabled={!isEditMode}
            />
          </Box>
          <Box {...styles.dropDownWithIcon}>
            <Box {...styles.dropdownTextContainer}>
              <Dropdown
                value={selectedCardType}
                data={cardsTypeDropdownData}
                transparentBorder={true}
                selectedData={setCardTypeData}
                minWidth={300}
                fullWidthContent={true}
                horizontalScroll={false}
                passFullItemOnSelection={true}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export const NewColumns = React.memo(
  ({
    isSelectAllChecked,
    onHeaderSelectionChange,
    isEditMode,
    cardsSelectDeselectAll,
    cardsColumnSelectionChange,
  }: ListHeaderComponentInterface) => {
    const { selectedCardType, setSelectedCardTypeChecked, cardsTypeDropdownData, updatedHeaderArray } = useStores(
      (root) => ({
        selectedCardType: root.onboarding.merchant.preferences.selectedCardType,
        setSelectedCardTypeChecked: root.setSelectedCardTypeChecked,
        cardsTypeDropdownData: root.onboarding.getCardsTypeList(),
        updatedHeaderArray: root.getUpdatedColumnHeaderArray(),
      }),
    )

    const onPressed = React.useCallback(
      (item: any, isChecked: string) => {
        cardsColumnSelectionChange(item?.name, !item?.isSelected)
      },
      [cardsColumnSelectionChange],
    )

    const getCheckedStateFromColumnData = (item: any) => {
      return item.isSelected
    }

    return (
      <Box>
        <CheckboxDropdown
          onHeaderSelectionChange={onHeaderSelectionChange}
          isSelectAllChecked={isSelectAllChecked}
          setSelectedCardTypeChecked={setSelectedCardTypeChecked}
          isEditMode={isEditMode}
          selectedCardType={selectedCardType}
          cardsTypeDropdownData={cardsTypeDropdownData}
          cardsSelectDeselectAll={cardsSelectDeselectAll}
        />
        <Box {...styles.header}>
          <ModBox {...styles.emptyColumn}>
            {arrowedName('Card SubType', 'ARROW_RIGHT')}
            {arrowedName('Card Scheme', 'ARROW_DOWN')}
          </ModBox>
          {updatedHeaderArray?.map((item, index) => {
            const isEmpty = item?.name?.length < 1
            const isChecked = getCheckedStateFromColumnData(item)
            return (
              <Fragment>
                <ModBox show={!isEmpty} key={index} {...styles.mainViewColumn(isEmpty)}>
                  <ModBox show={!isEmpty}>
                    <CheckBox
                      iconSize={20}
                      color={isEditMode ? (isChecked ? 'BLUE_SHADE' : 'GREY_MATTE') : 'DARK_GREY'}
                      checked={isChecked}
                      onChange={(isChecked: string) => onPressed(item, isChecked)}
                      disabled={!isEditMode}
                    />
                  </ModBox>
                  <SpacerNew size={4} direction="vertical" />
                  <TextNew fontSize={12} color={'BLACK'}>
                    {item?.name}
                  </TextNew>
                </ModBox>
              </Fragment>
            )
          })}
        </Box>
      </Box>
    )
  },
)
